import React from "react";
import { Link, withRouter } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { Config } from "../../Config";
import Installment from "../../assets/images/Installment.svg";
import Guarantee from "../../assets/images/guarant.svg";
import Club from "../../assets/images/club.svg";
import StopWatch from "../../assets/images/stopWatch.svg";
import AddCart from "../../assets/images/addCart.svg";

const MarketsItem = (props) => {
  return (
    <React.Fragment>
      {props.loading ? (
        props.marketsItemData.map((item, index) => {
          return (
            <div key={index} className="productItem">
              <div className="imageFigure">
                <Skeleton highlightColor={Config.skeletonHighlightColor} width="100%" height="100%" />
              </div>
              <div className="productDetail">
                <Link to="" className="productTitle">
                  <Skeleton highlightColor={Config.skeletonHighlightColor} width="100%" height="100%" />
                </Link>
                <p className="productAmount">
                  <Skeleton highlightColor={Config.skeletonHighlightColor} width="100%" height="100%" />
                </p>
              </div>
            </div>
          );
        })
      ) : (
        <React.Fragment>
          {props.marketsItemData.map((item, index) => {
            return (
              <div className="wrapperHelp">
                <Link to={`/markets/${item.id}/${item.name.replaceAll(" ", "-")}`} key={index} className="productItem">
                  <div className="imageFigure">
                    <span className="plink">
                      <img src={item.imageAddress} alt={item.name} className="productImage" />
                    </span>
                  </div>
                  <div className="productDetail">
                    <span className="productTitle">{item.name}</span>
                  </div>
                  <div className="priceBox">
                    <div className="item2">
                      <div className="exist">
                        <span class="green"></span>
                        {item.origin} به {item.destination}
                      </div>
                    </div>
                  </div>
                  <div className="addCart">
                    <span>اطلاعات بیشتر</span>
                  </div>
                </Link>
              </div>
            );
          })}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default React.memo(withRouter(MarketsItem));
